import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Space, Input, Row, Checkbox } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import './location.filter.css';
import { fetchKeySearchSkills } from "../../../../redux/actions";
import { debounce } from "../../../../shared/helpers";
import { useParams } from "react-router-dom";

const FilterSkill = (props) => {
   const dispatch = useDispatch();
   const { id, name } = useParams();
   const [SkillValue, setSkillValue] = useState([]);
   const [defaultValue, setDefaultValue] = useState();

   const [searchtext, setSearch] = useState();
   const skills = useSelector(state => state.searchSkillListingReducer.skills);
   const [checkedItems, setCheckedItems] = useState([]);


   useEffect(() => {
      if (props.skillObj) {
         setDefaultValue(props.skillObj)
      }
   }, [props])

   useEffect(() => {
      var options = []
      if (skills && skills?.result) {

         for (var i = 0; i < skills?.result?.length; i++) {
            options = [...options,
            {
               value: skills?.result?.[i]?._id.replace(/\+/g, " Plus"),
               value2: skills?.result?.[i]?.skillId,
               count: skills?.result?.[i]?.count
            }]
         }
         //append selected cities in suggestions array
         if (props.check && props.check.length > 0) {
            for (var j = 0; j < props.check.length; j++) {
               options = [
                  {
                     value: props.check[j].name,
                     value2: props.check[j].id,
                     count: props.check[j].count

                  },
                  ...options,
               ];
            }
         }
         //creating unique array
         var uniqueArr = [];
         options.forEach(option => {
            if (!uniqueArr.some(item => item.value === option.value)) {
               uniqueArr.push(option);
            }
         });

      setSkillValue(uniqueArr.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value?.toLowerCase())));
    }
    // setSkillValue(options);
  }, [skills]);

   useEffect(() => {
      var options = []
      if (skills?.length > 0) {

         for (var i = 0; i < skills?.result?.length; i++) {
            options = [...options,
            {
               value: skills?.result?.[i]?._id,
            }]
         }
         setSkillValue(options);
      }
   }, [skills])

   const onChange = (e) => {
      // e.preventDefault();

      // let value = JSON.parse(e.target.value)
      if (e.target.checked) {
         props.setCheckSkillId((prev) => [...prev, e.target.value]);
         props.setcheck((prev) => [
            ...prev,
            {
               name: e.target.value,
               id: e.target.value,
               count: parseInt(e.target.count)
            },
         ]);
      } else {
         props.setCheckSkillId(
            props?.checkSkillId.map((v) => v.replace(/\+/g, " ")).filter((item) => item !== e.target.value)
         );
         props.setcheck(props?.check.filter((item) => {
            return item.id !== e.target.value && item.ids !== e.target.value;
         }));
      }

      if (props.mobileFilter) {
         props.setVisible(false)

      }
   };

   const onLocationSearch = (value) => {
      if (Object.keys(props.searchLocationFilter).length) {
         const query = `skill=${value}`
         const params = {
            value: query,
            body: props.searchLocationFilter,
         };
         dispatch(fetchKeySearchSkills(params))
      } else {
         const obj = {
            value: value,
            type: "skill",
         };
         const params = { obj };
         dispatch(fetchKeySearchSkills(params))
      }
   }


   useEffect(() => {
      if (props.emptySkillInput == '' && !props.searchLocationFilter) {
         dispatch(fetchKeySearchSkills());
      }
   }, [props.emptySkillInput])

   const getCheckedValues = (value) => {
      if (props.checkSkillId?.map((v) => v.replace(/\+/g, " ")).includes(value)) {
         return true;
      } else {
         return false;
      }
   };

   return (
      <div className="location-suggestion-view" style={{ overflow: "auto" }}>
         <Input
            onChange={debounce((e) => onLocationSearch(e.target.value))}
            className='filter-search-input'
            placeholder="Search"
            value={props.emptySkillInput}
            prefix={<SearchOutlined />}
         />
         <Radio.Group onChange={onChange} className='location-radios-grp' value={props?.check}>
            <Space direction="vertical" style={{ width: "100%" }}>
               {!searchtext ?
                  <div className={`location-lists-container ${SkillValue?.length > 5 ? 'show-scrollbar' : ''}`}>
                     {SkillValue?.length ? SkillValue.map((items, index) => {
                        return ((items?.value?.indexOf("&") < 0) && (items?.value?.indexOf("+") < 0)) && items?.value ? (
                           <div style={{ display: 'flex', width: "100%", marginTop: index == 0 ? "0px" : "10px" }} key={index}>
                              <div
                                 style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "inherit",
                                 }}
                              >
                                 <Checkbox
                                    checked={getCheckedValues(items.value)}
                                    onChange={onChange}
                                    value={items.value}
                                    value2={items.value2}
                                    value3={items.value3}
                                    count={items.count}
                                    key={index}
                                 >
                                    <div
                                       style={{
                                          display: "flex",
                                          justifyContent: "space-between",

                                       }}
                                    >
                                       {" "}
                                       <div>{items?.value}</div>
                                    </div>
                                 </Checkbox>
                                 {/* {id || props?.fromCandMkt ? null : <> <div className="countDiv">({items?.count})</div> </>} */}
                              </div>

                           </div>
                        ) : null
                     }) : <div style={{ display: 'flex', justifyContent: 'center', color: '#7e7e7e' }}> No results found </div>}
                  </div> :
                  searchtext.map((items, index) => {
                     return (
                        <Radio
                           key={index}
                           value={defaultValue ? defaultValue : JSON.stringify(items)}
                           className="location-radio"
                           //  onChange={onChange} 
                           // checked={items?.value == props?.regionObj}
                           checked={props?.regionObj?.value ?
                              items?.value == props?.regionObj?.value
                              :
                              items?.value == props?.regionObj
                           }
                        >
                           {items.value}
                        </Radio>
                     )
                  })
               }
            </Space>
         </Radio.Group>
      </div>
   )
}
export default FilterSkill;